import CryptoJS from 'crypto-js';

const cryptKey = 'QYv+F3w5mz1GtlGRf9tzBw==';
const cryptIV = 'm+AqCS/DsVZywLyNCYFivQ==';

export default {
    // 加密
    encrypt(word) {
        let key = CryptoJS.enc.Base64.parse(cryptKey);
        let iv = CryptoJS.enc.Base64.parse(cryptIV);
        let data = CryptoJS.enc.Utf8.parse(word);
        let encrypted = CryptoJS.AES.encrypt(data, key, {
            iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        return encrypted.toString();
    },
    // 解密
    decrypt(word) {
        let key = CryptoJS.enc.Base64.parse(cryptKey);
        let iv = CryptoJS.enc.Base64.parse(cryptIV);
        let decrypt = CryptoJS.AES.decrypt(word, key, {
            iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    },
};
